import styled from 'styled-components';

export const HeroWrapper = styled.div<{ blur: boolean }>`
  width: 100%;

@media only screen and (min-width: 768px) {
   .commerce-hero-content {
    -webkit-filter: ${props => (props.blur ? 'blur(6px)' : 'none')};
    filter: ${props => (props.blur ? 'blur(6px)' : 'none')};
    height: 100%;
  }
 }
`;
